<template>
	<div class="row">
		<!--Tabla < md -->
		<div class="col-12 d-lg-none">
			<table class="table">
				<thead class="colorCabeceraTabla">
					<tr>
						<th class="fuenteEncTabla">Nombre del producto</th>
					</tr>
				</thead>
				<tbody>
					<tr name="item.codArticulo" v-bind:key="item.codArticulo" v-for="item in items">
						<th class="bg-white text-left p-1 m-0">
							<a
								:title="item.descripcion"
								@click="routerLink(item)"
								class="fuenteDescTabla mt-1 link"
								v-b-tooltip.hover
							>{{item.descripcion}}</a>							
							<span class="p-0 m-0 precioAnt d-inline-block col-12">
								Precio anterior:
								<span v-text="agregarComas(item.precioAnterior)" />
							</span>							
							<span class="p-0 m-0 precioNvoText d-inline-block">
								Precio nuevo:
								<span
									class="precioNvoCantVerde d-inline-block"
									v-if="item.precioNuevo <= item.precioAnterior"
								>
									<span v-text="agregarComas(item.precioNuevo)" />
								</span>
								<span class="precioNvoCantRojo d-inline-block" v-else>
									<span v-text="agregarComas(item.precioNuevo)" />
								</span>
							</span>
						</th>
					</tr>
				</tbody>
			</table>
		</div>

		<!--Tabla > md -->
		<div class="row col-12 d-none d-lg-block">
			<table class="table">
				<thead class="colorCabeceraTabla">
					<tr class="fuenteEncTabla">
						<th class="text-left">Nombre del producto</th>
						<th class="text-left">Laboratorio</th>
						<th class="text-right">Precio Anterior</th>
						<th class="text-right">Precio Nuevo</th>
						<th class="text-right">Fecha</th>
					</tr>
				</thead>
				<tbody>
					<tr
						class="bg-white text-left fuenteDescTabla"
						name="item.codArticulo"
						v-bind:key="item.codArticulo"
						v-for="item in items"
					>
						<th class="text-left p-1 m-0 vertical-align-center">
							<div :title="item.descripcion" class="wNombreProducto" v-b-tooltip.hover>
								<a @click="routerLink(item)" class="wNombreProducto link">{{item.descripcion}}</a>
							</div>
							<div class="wFormulaProducto" v-b-tooltip.hover>{{item.formula}}</div>
						</th>
						<td class="p-1 pl-3 m-0 vertical-align-center">
							<span class="wLaboratorio">{{item.marca}}</span>
						</td>
						<td class="p-1 m-0 mr-3 text-right vertical-align-center">
							<div class="wPrecioAnt">
								<span v-text="agregarComas(item.precioAnterior)" />
							</div>
						</td>
						<td class="p-1 m-0 pr-3 text-right vertical-align-center">
							<div class="wPrecioNvoVerde text-right" v-if="item.precioNuevo <= item.precioAnterior">
								<span v-text="agregarComas(item.precioNuevo)" />
							</div>
							<div class="wPrecioNvoRojo text-right" v-else>
								<span v-text="agregarComas(item.precioNuevo)" />
							</div>
						</td>
						<td class="p-1 m-0 text-right vertical-align-center">
							<div class="wFecha">{{item.fecha | format-date('DD/MMM/YY')}}</div>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		
		
		<div class="col-12 pt-3 d-flex justify-content-center">
			<ul class="pagination">
				<li class="page-item " v-show="current_page > 1">
					<a @click="navegar(1)" class="page-link" role="button">«</a>
				</li>
				<li v-show="current_page > 1" class="page-item">
					<a
						@click="navegar(current_page-1)"
						class="page-link text-decoration-none d-none d-md-block"
						role="button"
					>Anterior</a>
				</li>
				<li :class="{active: current_page == pag}" :key="pag" class="page-item" v-for="pag in paginas">
					<a @click="navegar(pag)" class="page-link">{{pag}}</a>
				</li>
				<li class="page-item" v-show="current_page < numPages">
					<a 	@click="navegar(current_page+1)" 
						class="page-link d-none d-md-block" 
						role="button">Siguiente</a>
				</li>
				<li class="page-item" v-show="current_page < numPages">
					<a @click="navegar(numPages)" class="page-link" role="button">»</a>
				</li>
			</ul>
		</div>	
		

		<!-- <div class="col-12 justify-content-center">
			<nav aria-label="Paginador">
				<ul class="pagination justify-content-center">
					<li class="page-item" v-show="current_page > 1">
						<a @click="navegar(1)" class="page-link" role="button">«</a>
					</li>

					<button @click="prevPage" v-show="current_page > 1" class="page-link funtePaginador">‹ Anterior</button>
					
					<li :class="{active: current_page == pag}" :key="pag" class="page-item" v-for="pag in paginas">
						<a @click="navegar(pag)" class="page-link">{{pag}}</a>
					</li>
					
					<button @click="nextPage" v-show="current_page < numPages" class="page-link funtePaginador ml-2">Siguiente ›</button>
					<li class="page-item" v-show="current_page < numPages">
						<a @click="navegar(numPages)" class="page-link" role="button">»</a>
					</li>
				</ul>
			</nav>
		</div> -->
	</div>
</template>

<script>
	export default {
		data() {
			return {}
		},
		props: ["items", "current_page", "numPages", "paginas"],
		methods: {
			routerLink(item) {
				this.$emit("clickItem", item)
			},
			agregarComas(number) {
				number = number.toFixed(2) + ""
				var x = number.split(".")
				var x1 = x[0]
				var x2 = x.length > 1 ? "." + x[1] : ""
				var rgx = /(\d+)(\d{3})/
				while (rgx.test(x1)) {
					x1 = x1.replace(rgx, "$1" + "," + "$2")
				}
				return x1 + x2
			},
			prevPage() {
				this.$emit("anterior")
			},
			nextPage() {
				this.$emit("siguiente")
			},
			navegar(pagina){
				this.$emit("navegar", pagina)
			}
		}
	}
</script>

<style scoped>
	.funtePaginador {
		font-family: "Open Sans";
		font-size: 14px;
		color: #0a2157;
	}
	.colorCabeceraTabla {
		background-color: #335198;
	}	
	/* sm */
	@media screen and (max-width: 767px) {
		.fuenteEncTabla {
			font-family: "Open Sans";
			font-size: 14px;
			color: #ffffff;
		}

		.fuenteDescTabla {
			font-family: "Open Sans";
			font-size: 14px;
			color: #273c6e;
		}

		.precioAnt {
			font-family: "Open Sans";
			font-size: 12px;
			font-weight: initial;
			color: #273c6e;
		}

		.precioNvoText {
			font-family: "Open Sans";
			font-size: 12px;
			color: #273c6e;
		}

		.precioNvoCantVerde {
			font-family: "Open Sans";
			font-size: 12px;
			color: #4fc147;
		}

		.precioNvoCantRojo {
			font-family: "Open Sans";
			font-size: 12px;
			color: #ff0000;
		}
	}

	/* md */
	@media screen and (min-width: 768px) and (max-width: 991px) {
		.fuenteEncTabla {
			font-family: "Open Sans";
			font-size: 14px;
			color: #ffffff;
		}

		.fuenteDescTabla {
			font-family: "Open Sans";
			font-size: 14px;
			color: #273c6e;
		}

		.precioAnt {
			font-family: "Open Sans";
			font-size: 12px;
			font-weight: initial;
			color: #273c6e;
		}

		.precioNvoText {
			font-family: "Open Sans";
			font-size: 12px;
			color: #273c6e;
		}

		.precioNvoCantVerde {
			font-family: "Open Sans";
			font-size: 12px;
			color: #4fc147;
		}

		.precioNvoCantRojo {
			font-family: "Open Sans";
			font-size: 12px;
			color: #ff0000;
		}
	}
	/*lg*/
	@media screen and (min-width: 992px) and (max-width: 1199px) {
		.wNombreProducto {
			font-family: "Open Sans", sans-serif;
			font-size: 14px;
			font-weight: bold;
			color: #273c6e;
		}

		.wLaboratorio {
			font-family: "Open Sans", sans-serif;
			font-size: 14px;
			font-weight: 600;
			font-weight: 600;
			color: #273c6e;
		}
		.wFormulaProducto {			
			font-family: "Open Sans", sans-serif;
			font-size: 12px;
			font-weight: 600;
			color: #273c6e;
		}
		.wPrecioAnt {
			font-family: "Open Sans", sans-serif;
			font-size: 14px;
			font-weight: 600;
			color: #273c6e;
		}

		.wPrecioNvoVerde {
			font-family: "Open Sans", sans-serif;
			font-size: 14px;
			font-weight: 600;
			color: #4fc147;
		}
		.wPrecioNvoRojo {
			font-family: "Open Sans", sans-serif;
			font-size: 14px;
			font-weight: 600;
			color: #ff0000;
		}

		.wFecha {
			font-family: "Open Sans", sans-serif;
			font-size: 14px;
			font-weight: 600;
			color: #273c6e;
		}
		.fuenteEncTabla {
			font-family: "Open Sans", sans-serif;
			font-size: 14px;
			color: #ffffff;
		}

		.fuenteDescTabla {
			font-family: "Open Sans", sans-serif;
			font-size: 14px;
			color: #273c6e;
		}
	}

	/*xl*/
	@media screen and (min-width: 1200px) {
		.wNombreProducto {			
			font-family: "Open Sans", sans-serif;
			font-size: 14px;
			font-weight: bold;
			color: #273c6e;
		}

		.wFormulaProducto {
			font-family: "Open Sans", sans-serif;
			font-size: 12px;
			font-weight: 600;
			color: #273c6e;
		}
		.wLaboratorio {
			font-family: "Open Sans", sans-serif;
			font-size: 14px;
			font-weight: 600;
			color: #273c6e;
		}

		.wPrecioAnt {
			font-family: "Open Sans", sans-serif;
			font-size: 14px;
			font-weight: 600;
			color: #273c6e;
		}

		.wPrecioNvoVerde {
			font-family: "Open Sans", sans-serif;
			font-size: 14px;
			font-weight: 600;
			color: #4fc147;
		}

		.wPrecioNvoRojo {
			font-family: "Open Sans", sans-serif;
			font-size: 14px;
			font-weight: 600;
			color: #ff0000;
		}
		.wFecha {
			font-family: "Open Sans", sans-serif;
			font-size: 14px;
			font-weight: 600;
			color: #273c6e;
		}
		.fuenteEncTabla {
			font-family: "Open Sans", sans-serif;
			font-size: 14px;
			color: #ffffff;
		}

		.fuenteDescTabla {
			font-family: "Open Sans", sans-serif;
			font-size: 14px;
			color: #273c6e;
		}
	}
</style>
